import type { FC, PropsWithChildren } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { DisclosureSection } from "web_myplann/Shared/Components/DisclosureSection";
import { hasAnyDetailValue } from "web_myplann/Shared/Utils/hasAnyDetailValue";

const PageResources = Resources.PortfolioDetail.Property;

type Props = {
	noun: "realEstate" | "vehicle";
	values: (string | number | null | undefined)[];
};

export const PropertyExtendedParams: FC<PropsWithChildren<Props>> = ({
	noun,
	values,
	children,
}) => {
	const { t } = useResource();

	if (!hasAnyDetailValue(...values)) {
		return null;
	}

	const nounLabel = t(
		noun === "vehicle"
			? PageResources.ParametersNounVehicle
			: PageResources.ParametersNounRealEstate,
	);

	return (
		<DisclosureSection
			labelCollapsed={t(PageResources.ShowParameters, { noun: nounLabel })}
			labelExpanded={t(PageResources.HideParameters, { noun: nounLabel })}
		>
			{children}
		</DisclosureSection>
	);
};
